<template>
  <el-table-column
    prop="mobile"
    sortable="custom"
    label="Mobil"
    show-overflow-tooltip
    min-width="150"
    show-tooltip-when-overflow
  >
    <template slot-scope="scope">
      {{ scope.row.mobile | phone }}
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'mobile',
};
</script>
